/** Decode base64 (with optional data-URL prefix) into a Blob. */
export function base64ToBlob(base64: string, contentType = 'application/octet-stream'): Blob {
  const normalized = base64.trim().replace(/^data:[^;]+;base64,/, '');
  const binary = atob(normalized);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new Blob([bytes], { type: contentType || 'application/octet-stream' });
}
